module.exports = __webpack_public_path__ + "img/big_intelligent.4b9387f5.png";